import { StatsReportsIdsEnum } from '@empathybroker/tsclient-stats/dist/enums/stats-reports-ids.enum';

import { ActionContext } from 'vuex';

import { CompareFilterEnum, FilterIdEnum } from '../../../enums';

import { ActionClass, AnalyticsState, ContextState, IdData, PeriodsData, RegularFilter } from '../../../models';

import { CONTEXT_CONSTS } from '../../context/context.consts';
import { ANALYTICS_CONSTS } from '../analytics.consts';

export class LoadDistDataAction implements ActionClass {

  public static async execute({ dispatch, commit, state, rootGetters }: ActionContext<AnalyticsState, any>,
    selectedId?: string): Promise<void> {
    let distData: PeriodsData;
    if (!selectedId) {
      distData = state.data.overall.dist;
    } else {
      const selectedIdData: IdData = state.data.ids[selectedId];
      if (!!selectedIdData) {
        distData = selectedIdData.dist;
      }
    }
    const context: ContextState = rootGetters[`${CONTEXT_CONSTS.moduleName}/${CONTEXT_CONSTS.getters.context}`];
    const reportId = LoadDistDataAction.getReportId(context, selectedId);
    const reportParams: any = {};
    if (!!selectedId) {
      reportParams.terms = selectedId;
    }
    try {
      const newDistData: Partial<PeriodsData> = {};
      if (!distData || !distData.currentPeriod) {
        newDistData.currentPeriod = await dispatch(ANALYTICS_CONSTS.actions.fetchStatsReport, {
          id: reportId,
          params: reportParams
        });
      }
      const periodToCompare = LoadDistDataAction.getPeriodToCompare(context);
      if (!!periodToCompare && (!distData || !distData[periodToCompare])) {
        const periodToCompareDates = LoadDistDataAction.getPeriodToCompareDates(periodToCompare, context);
        newDistData[periodToCompare] = await dispatch(ANALYTICS_CONSTS.actions.fetchStatsReport, {
          id: reportId,
          params: {
            ...reportParams,
            startDate: periodToCompareDates[0],
            endDate: periodToCompareDates[1]
          }
        });
      }
      if (!!Object.keys(newDistData).length) {
        commit(ANALYTICS_CONSTS.mutations.setDistData, {
          data: newDistData,
          selectedId: selectedId
        });
      }
    } catch (error) {
      throw error;
    }
  }

  public static getPeriodToCompare(context: ContextState): CompareFilterEnum {
    const compareFilter = (context.filters[FilterIdEnum.COMPARE] as RegularFilter);
    return (((compareFilter && compareFilter.selectedValues[0]) || undefined) as CompareFilterEnum);
  }

  public static getPeriodToCompareDates(periodToCompare: CompareFilterEnum, context: ContextState): Date[] {
    const periodDates = context.filters[FilterIdEnum.DATE].selectedValues;
    return {
      [CompareFilterEnum.PREVIOUS_PERIOD]: () => {
        const endDate = new Date(periodDates[0]);
        const startDate = new Date(endDate.getTime() - (periodDates[1] - periodDates[0]));
        return [startDate, endDate];
      },
      [CompareFilterEnum.YEAR_OVER_YEAR]: () => {
        const endDate = new Date(periodDates[1]);
        endDate.setUTCFullYear(endDate.getUTCFullYear() - 1);
        const startDate = new Date(endDate.getTime() - (periodDates[1] - periodDates[0]));
        return [startDate, endDate];
      }
    }[periodToCompare]();
  }

  private static getReportId(context: ContextState, selectedId?: string): StatsReportsIdsEnum {
    const periodDates = context.filters[FilterIdEnum.DATE].selectedValues;
    const auxDate = new Date(periodDates[0]);
    auxDate.setUTCDate(auxDate.getUTCDate() + 1);
    const loadHourlyDist = (periodDates[1] <= auxDate.getTime());
    if (!!selectedId) {
      return (loadHourlyDist ? StatsReportsIdsEnum.HOURLY_DIST_TERM_SUCESS : StatsReportsIdsEnum.DAILY_DIST_TERM_SUCESS);
    }
    return (loadHourlyDist ? StatsReportsIdsEnum.HOURLY_DIST : StatsReportsIdsEnum.DAILY_DIST);
  }

}
